import axios from 'axios';
import { User, RegisterCredentials } from './authSlice';
import apiClient from '../../api/apiClient';
import { jwtDecode } from 'jwt-decode';  // Named import kullanıyoruz

// API URL'ini çevre değişkenlerinden al veya varsayılan değeri kullan
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// JWT token'dan kullanıcı ID'sini çıkar
const getUserIdFromToken = (token: string): number | null => {
  try {
    const decoded: any = jwtDecode(token);
    return decoded.user_id || null;
  } catch (error) {
    console.error('Token decode error:', error);
    return null;
  }
};

// Auth servisi
const authService = {
  // Kayıt işlemi
  register: async (userData: RegisterCredentials) => {
    const response = await axios.post(`${API_URL}/auth/register`, userData);

    // Token'ı kaydet
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }

    // Refresh token'ı da kaydet
    if (response.data.refresh_token) {
      localStorage.setItem('refreshToken', response.data.refresh_token);
    }

    return response.data;
  },

  // Login işlemi - FastAPI OAuth2 formatına uygun
  login: async (credentials: { username: string; password: string }) => {
    // FormData kullanarak x-www-form-urlencoded formatında gönder
    const formData = new URLSearchParams();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);

    const response = await axios.post(`${API_URL}/auth/login`, formData.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    // Access token'ı kaydet
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }

    // Refresh token'ı da kaydet
    if (response.data.refresh_token) {
      localStorage.setItem('refreshToken', response.data.refresh_token);
    }

    return response.data;
  },

  // Mevcut kullanıcı bilgilerini al
  getCurrentUser: async (): Promise<User> => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Token'dan user_id'yi çıkar
    const userId = getUserIdFromToken(token);
    if (!userId) {
      throw new Error('Invalid token format');
    }

    // Kullanıcı bilgilerini al
    const response = await apiClient.get<User>(`/users/${userId}`);
    return response;
  },

  // Refresh token
  refreshToken: async (refreshToken: string) => {
    const response = await axios.post(`${API_URL}/auth/refresh`, { refresh_token: refreshToken });

    // Yeni access token'ı kaydet
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }

    // Yeni refresh token'ı da kaydet
    if (response.data.refresh_token) {
      localStorage.setItem('refreshToken', response.data.refresh_token);
    }

    return response.data;
  },

  // Email verification
  verifyEmail: async (data: { email: string; code: string }) => {
    const response = await axios.post(`${API_URL}/auth/verify-email`, data);
    return response.data;
  },

  // Resend verification code
  resendVerification: async (email: string) => {
    const response = await axios.post(`${API_URL}/auth/resend-verification`, { email });
    return response.data;
  },

  // Forgot password
  forgotPassword: async (email: string) => {
    const response = await axios.post(`${API_URL}/auth/forgot-password`, { email });
    return response.data;
  },

  // Reset password
  resetPassword: async (data: any) => {
    const response = await axios.post(`${API_URL}/auth/reset-password`, data);
    return response.data;
  },
};

export default authService;